export default __webpack_public_path__ + "static/media/Tripp_Lite.f5112e22.png";